import { css } from 'styled-components';
import { rem } from 'polished';
import isFavoriteCueStyles from './isFavoriteCueStyles';

const colorVariantContainerStyles = () => css`
    border-top-left-radius: ${({ theme }) => rem(theme.base.borderRadius.default)};
    border-top-right-radius: ${({ theme }) => rem(theme.base.borderRadius.default)};
    cursor: ${({ colorVariant, allowCopyToClipboard }) =>
        colorVariant && allowCopyToClipboard ? 'pointer' : 'default'};
    display: block;
    height: 100%;
    min-width: ${rem(12)};
    position: relative;
    transition: all 0.3s ease-in-out;
    width: 100%;

    ${({ showLabel }) =>
        !showLabel &&
        css`
            border-bottom-left-radius: ${({ theme }) => rem(theme.base.borderRadius.default)};
            border-bottom-right-radius: ${({ theme }) => rem(theme.base.borderRadius.default)};
        `}

    ${({ themeMode }) =>
        themeMode === 'darkMode' &&
        css`
            background-color: ${({ theme }) => theme.base.grays.grayLighter};
        `}

    ${({ themeMode }) =>
        themeMode === 'lightMode' &&
        css`
            background-color: ${({ theme }) => theme.base.grays.grayLightest};
        `}

    ${({ showIsFavorite }) =>
        showIsFavorite &&
        css`
            ${isFavoriteCueStyles}
        `}
`;

export default colorVariantContainerStyles;
